module.exports = __webpack_public_path__ + "static/media/template_qrcode.17a00ab7.png";